import { motion } from "motion/react";
import { useReducedMotion } from "../../hooks/useReducedMotion";
import styles from "./PageHeader.module.css";

interface PageHeaderProps {
  eyebrow: string;
  title: string;
  description?: string;
  wideDescription?: boolean;
  invert?: boolean;
}

export function PageHeader({
  eyebrow,
  title,
  description,
  wideDescription = false,
  invert = false,
}: PageHeaderProps) {
  const reduceMotion = useReducedMotion();

  return (
    <motion.header
      className={`${styles.header} ${invert ? styles.invert : ""}`}
      initial={reduceMotion ? false : { opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.45 }}
      transition={{ duration: 0.78, ease: [0.22, 1, 0.36, 1] }}
    >
      <p className={styles.eyebrow}>{eyebrow}</p>
      <div>
        <h2 aria-label={title.replaceAll("\n", " ")}>
          {title.split("\n").map((line, index) => (
            <motion.span
              key={`${line}-${index}`}
              aria-hidden="true"
              style={{ display: "block" }}
              initial={reduceMotion ? false : { opacity: 0, y: "0.55em" }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.7 }}
              transition={{
                delay: 0.08 + index * 0.12,
                duration: 0.72,
                ease: [0.22, 1, 0.36, 1],
              }}
            >
              {line}
            </motion.span>
          ))}
        </h2>
        {description && (
          <p className={`${styles.description} ${wideDescription ? styles.wideDescription : ""}`}>
            {description}
          </p>
        )}
      </div>
    </motion.header>
  );
}
